
import React from "react";
import LazyLoad from "react-lazyload"; 
import { Link } from "react-router-dom";
const ImageGallery = ({ images }) => {

  // Proper download using fetch + blob
  const handleDownload = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl, { mode: "cors" });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = imageUrl.split("/").pop();  
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(url);  
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <>
    <div className="breadcrumb">
    <h2>Calendar</h2>
    <ul>
        <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
        <li>|</li>
        <li>  ACADEMICS</li>
        <li>|</li>
        <li>Calendar</li>
    </ul>
</div>
        <div className="inner_page faculty_inner">
            <div className="container">
            <div className="row">
                {images.map((img, index) => (
                    <div key={index} className="col-lg-4 col-md-6 col-12 downloadimg"> 
                    <h6 class="headcenter">{img.title}</h6>
                    <a data-magnify="gallery" data-src={img.url} data-group="a" href={img.url}>
                        <LazyLoad>
                        <img src={img.url} className="img-fluid mx-auto d-block bordered_img" alt={img.alt}/>
                        </LazyLoad> 
                    </a> 
                    <button onClick={() => handleDownload(img.url)} className="downloadbtn"> <i class="bi bi-file-earmark-arrow-down"></i>   </button>
                    </div>
                ))}
                </div>
                </div>
            </div>
    </>
  );
};

export default ImageGallery;
